<template>
  <div class="reviews">
    <div class="title">{{params.messages.title}}</div>
    <shops_detail_reviewform :params='params.form'/>
    <shop_reviews_item v-for="item in params.items" :params='item'/>
    <div v-html="params.pagen_html"></div>
  </div>
</template>

<script>
import Shops_detail_reviewform from "./shops_detail_reviewform.vue";
import Shop_reviews_item from "./shop_reviews_item.vue";

export default {
  name: "shop_reviews_block",
  components: {Shop_reviews_item, Shops_detail_reviewform},
  selector: '.shop_reviews_block',
  props:{params: Object},
}
</script>

<style scoped>
  .reviews .title{
    text-align:left;
    font-weight: 800;
  }
  @media (max-width: 768px) {
    .reviews .title{
      text-align:center;
    }
  }
</style>